import { Converter } from '../types/converter';

export const magneticFluxConverter: Converter = {
  id: 'magneticFlux',
  name: 'Magnetic Flux Converter',
  icon: 'Magnet',
  categories: ['magnetism'],
  units: [
    // SI unit and prefixes
    { name: 'Weber', symbol: 'Wb', factor: 1 },
    { name: 'Milliweber', symbol: 'mWb', factor: 0.001 },
    { name: 'Microweber', symbol: 'µWb', factor: 1e-6 },
    
    // Equivalent units
    { name: 'Volt second', symbol: 'V*s', factor: 1 },
    
    // CGS and other units
    { name: 'Unit pole', symbol: 'unit pole', factor: 1.256637061436e-7 },
    { name: 'Megaline', symbol: 'megaline', factor: 1e-2 },
    { name: 'Kiloline', symbol: 'kiloline', factor: 1e-5 },
    { name: 'Line', symbol: 'line', factor: 1e-8 },
    { name: 'Maxwell', symbol: 'Mx', factor: 1e-8 },
    
    // Area-based units
    { name: 'Tesla square meter', symbol: 'T*m²', factor: 1 },
    { name: 'Tesla square centimeter', symbol: 'T*cm²', factor: 1e-4 },
    { name: 'Gauss square centimeter', symbol: 'G*cm²', factor: 1e-8 },
    
    // Quantum unit
    { name: 'Magnetic flux quantum', symbol: 'Φ₀', factor: 2.067833848e-15 }
  ]
};
